module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/mouse-d378c232e3e3b6903551837f5663f693.svg";